import { PhoneRequest } from "../v1.model";

export class NewCustomerRequest{
    document: string;
    name: string;
    email?: string;
    birthdate?: Date;
    phone?: PhoneRequest;
}